import { mappingVariant } from '../../../../pages/Registries/badgeVariants';
export function money(amount) {
    return amount && Number.isFinite(Number(amount)) ? Number(amount).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
    }) : '—';
}
export function cents(amount) {
    return amount === undefined ? '—' : money(String(Number(amount.toString()) / 100));
}
const reasons = {
    NOT_EQUIVALENT: 'broader/narrower match not used',
    NO_RATE_BOOK_ACCESS: 'rate book access needed',
    NO_HISTORY: 'no history',
    NO_TEAMMATES: 'no teammates on the pursuit',
    NO_COMPETITORS: 'no competitors on the pursuit',
    UNMAPPED: 'not matched',
    NOT_MATCHED: 'not matched',
    BROADER_NARROWER: 'broader/narrower match not used',
    AS_WRITTEN_ONLY: 'priced as written',
    NEEDS_DECISION: 'decide mapping first',
    RATE_BOOK_ACCESS_NEEDED: 'rate book access needed'
};
export function emptyReason(reason) {
    return reasons[reason.toUpperCase()] ?? reason.replace(/_/g, ' ').toLowerCase();
}
export function linkLabel(link) {
    if (link?.decision === 'as_written_only') return 'Priced as written';
    if (link?.decision === 'price_from_source_vehicle') return `Priced from ${link.sourceVehicleName || link.entryVehicleName}`;
    return ({
        EQUIVALENT: 'Equivalent',
        VEHICLE_MISMATCH: 'Vehicle mismatch',
        REVIEW_NEEDED: 'Needs review',
        UNMAPPED: 'Not matched',
        BROADER: 'Broader',
        NARROWER: 'Narrower'
    })[link?.mappingStatus ?? ''] ?? 'Not matched';
}
export function pricingLinkVariant(link) {
    const status = link?.mappingStatus ?? '';
    return mappingVariant([
        'EQUIVALENT',
        'BROADER',
        'NARROWER'
    ].includes(status) ? 'APPROVED' : status, status);
}
export function basisLabel(row) {
    const using = row.using;
    if (using?.differsFromSuggestion) return `≠ suggested · ${using.reason.slice(0, 40)}`;
    if (row.link?.decision === 'price_from_source_vehicle') return `Explicit decision: price from ${row.link.sourceVehicleName || row.link.entryVehicleName} (${row.link.decidedByName}, ${dateLabel(row.link.decidedAt)})`;
    if (using?.basis === 'adjusted_suggestion') return `adjusted suggestion (${row.adjustment?.pct ?? ''}%)`;
    return ({
        suggestion: 'suggested',
        observation: 'from observation',
        manual: 'manual',
        escalated: 'escalated',
        workbook: 'from price volume',
        seeded_government: 'Section B rate',
        seeded_ceiling: 'Section B rate'
    })[using?.basis ?? ''] ?? '';
}
export function dateLabel(value) {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        timeZone: 'UTC'
    });
}
export function rangeMillions(low, high) {
    const display = (value)=>(Number(value.toString()) / 100000000).toLocaleString('en-US', {
            maximumFractionDigits: 2
        });
    return `$${display(low)}–${display(high)}M`;
}
